
import { Component, Vue } from 'vue-property-decorator'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { showErrors } from '@/utils/snack'
import { utcDateTimeToLocal } from '@/utils/dateTime'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import AppDialog from '@/components/AppDialog.vue'
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue'
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue'
import AppSimpleSelector from '@/components/AppSimpleSelector.vue'
import AppSimpleTextField from '@/components/AppSimpleTextField.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppSimpleButton from '@/components/AppSimpleButton.vue'
import AppFormItem from '@/components/AppFormItem.vue'
import { OrderModel } from '@/interfaces/order'
import { findOrder } from '../OrderList/gql'
import { OrderStatusText } from '@/helpers/order'
import { TypedGqlError } from '@/interfaces/error'
import { formatCurrency } from '@/utils/currency'

@Component({
  components: {
    AppBreadcrumbs,
    AppRefreshAndExport,
    AppDialog,
    AppSimpleTextField,
    AppSimpleSelector,
    AppDatePicker,
    AppTextarea,
    AppTextField,
    AppSimpleDistrictSelector,
    AppSimpleButton,
    AppFormItem
  }
})

export default class OrderDetail extends Vue {
  breadcrumbs: Breadcrumb[] = [
    {
      text: '订单管理'
    },
    {
      text: '订单',
      to: { name: 'OrderList' }
    }
  ]

  windowSize = {
    w: 0,
    h: 0
  }

  actionsHeight = 51

  utcDateTimeToLocal = utcDateTimeToLocal
  formatCurrency = formatCurrency
  OrderStatusText = OrderStatusText

  loading = false
  headers = [
    { text: '征订周期', value: 'period', sortable: false, width: 150 },
    { text: '标题', value: 'title', sortable: false },
    { text: 'ISBN', value: 'isbn', sortable: false },
    { text: '单价', value: 'price', sortable: false },
    { text: '数量', value: 'count', sortable: false }
  ]

  options = {
    sortBy: ['count'],
    sortDesc: [true]
  }

  goods: any = null

  order: OrderModel | null = null
  orderId = ''

  get buyer () {
    const address = this.order?.address
    const area = address?.school.area.mergerName
    const { school, year, className, realname, phone } = address as any
    return area + '-' + school.name + '-' + year + '年入学-' + className + '-' + realname + '-' + (phone || '-')
  }

  async mounted () {
    this.onResize()
    const { id } = this.$route.params
    this.orderId = id
    await this.getOrderById()
  }

  // 更新地址
  async updateAddress () {
    try {
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 查询 by id
  async getOrderById () {
    try {
      const result = await this.$apollo.query({
        query: findOrder,
        variables: {
          orderId: +this.orderId
        }

      })
      if (result) {
        this.order = result.data.findOrder
        this.breadcrumbs.push({ text: `${result.data.findOrder.orderNumber}` })
        this.goods = this.order?.items
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  exportHandler () {
    // todo
  }

  editOrder (item: any, type: string) {
    this.$router.push({
      name: 'EditOrder',
      params: {
        type: type,
        id: item.id
      }
    })
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
  }
}
